import WrapperService from "@/modules/core/services/wrapper-service";
import {createPageableParams} from "@/modules/core/services/table-utils";

const API_URL1 = process.env.VUE_APP_ROOT_API + "/api/v1/eventlog/facilities"
const API_URL2 = process.env.VUE_APP_ROOT_API + "/api/v1/eventlog/buildings"
const API_URL3 = process.env.VUE_APP_ROOT_API + "/api/v1/eventlog"

const serviceName = "EventLog-Service: ";
export default class EventLogService {

  static async postEventLog(eventLog, successF, errorF) {
    WrapperService.post(API_URL3, eventLog, serviceName, successF, errorF);
  }

  static async deleteFromAPI(eventLogId, successF, errorF) {
    await WrapperService.delete(API_URL3 + "/" + eventLogId, serviceName, successF, errorF)
  }

  static async readEventLogByFacility(facilityID, successF, errorF) {
    await WrapperService.get(API_URL1 + "/" + facilityID, null, serviceName, successF, errorF);
  }

  static async readEventLogByBuilding(buildingID, successF, errorF) {
    await WrapperService.get(API_URL2 + "/" + buildingID, null, serviceName, successF, errorF);
  }

  static async readPageableEventLogsByBuilding(buildingId, eventLogType, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], [])
    params.append("eventLogType", eventLogType);

    await WrapperService.get(API_URL2 + "/page/" + buildingId, { params: params}, serviceName, successF, errorF);
  }

  static async readPageableEventLogsByFacility(facilityId, eventLogType, page, size, search, sort, sortAsc, successF, errorF) {
    let params = createPageableParams(page, size, search, sort, sortAsc, [], [])
    params.append("eventLogType", eventLogType);

    await WrapperService.get(API_URL1 + "/page/" + facilityId, { params: params}, serviceName, successF, errorF);
  }
}
